export default "__VITE_ASSET__T6DHj8Nh__"